import { If } from 'aa_common/front-end/components'
import InputNumber from 'aa_common/front-end/components/form/form-input-number'
import { defaultTo, ifElse, isEmptyValue } from 'aa_common/front-end/helpers'
import { yenCheckNull } from 'common/helpers'
import { useNextEffect } from 'common/hooks/use-next-effect'
import { getNs } from 'common/i18n-config'
import { LedgerSettingsItem } from 'common/models'
import Form from 'components/molecules/Form'
import { useFormContext } from 'react-hook-form'

import { useGetAssetLedger } from '../hooks/use-get-asset-ledger'
import { useIsFullImpairment } from '../hooks/use-is-full-impairment'
import { AntInputAlignRight } from '../styles'
import { FIELD_NAMES } from '../validation'

const { FormField } = Form
const { t, useNsReady } = getNs(['components/organisms/assets/asset-impairment', 'common'])

const FieldName = FIELD_NAMES.impair_residual_value

type ImpairmentResidualProps = {
  ledgerSetting?: LedgerSettingsItem
}

export const ImpairmentResidual = ({ ledgerSetting }: ImpairmentResidualProps) => {
  useNsReady()

  const { setValue } = useFormContext()
  const assetLedger = useGetAssetLedger(ledgerSetting)

  const disabled = useIsFullImpairment()
  const defaultValue = defaultTo(assetLedger?.residual_amount, 0)

  useNextEffect(() => {
    disabled && setValue(FieldName, null, { shouldValidate: true })
    !disabled && setValue(FieldName, defaultValue, { shouldValidate: true })
  }, [setValue, disabled, defaultValue])

  return (
    <FormField title={t('impair_residual_value')} required={!disabled} disabled={disabled}>
      <If condition={disabled}>
        <span className="disabled-content">ー</span>
      </If>
      <If condition={!disabled}>
        <InputNumber
          name={FieldName}
          min={0}
          className={AntInputAlignRight}
          formatter={value => ifElse(!isEmptyValue(value), `${yenCheckNull(value)}`, '')}
          controls={false}
        />
      </If>
    </FormField>
  )
}
